import React from "react";

/**
 * Placeholder for a code-split view while its chunk loads. Holds the same
 * height as the view area below the header so the page doesn't collapse, and
 * announces itself for screen readers the way the other view skeletons do.
 */
const ViewLoadingSkeleton: React.FC = () => (
  <div
    role="status"
    aria-label="Loading view"
    className="flex h-[calc(100vh-64px)] items-center justify-center"
  >
    <div className="w-8 h-8 border-[3px] border-warm-border border-t-warm-blue rounded-full animate-spin" />
  </div>
);

export default ViewLoadingSkeleton;
